import TicketsocketCookie from '../typescript/TicketsocketCookie';
import { DOMcreateElement } from '../typescript/TSXDomParse';
var animationTimeout = 450;
/**
 * TicketCartLineItem.
 *
 * Cart line item element
 *
 * autho: nick.arcuri@spartan.com
 *
 * @param {Props}
 *
 */
export default function TicketCartLineItem(_a) {
    var lineItem = _a.lineItem, key = _a.key;
    var className = 'ticket-cart__line-item';
    /**
     * remove.
     *
     * On click, removes line item from cart/cookie
     *
     * @param {Event} e
     */
    var remove = function (e) {
        var _a;
        var target = e.target;
        var index = parseInt((_a = target.dataset.key) !== null && _a !== void 0 ? _a : '-1');
        if (index > -1) {
            TicketsocketCookie.removeTicket(index);
            var self_1 = document.querySelector("." + className + "[data-key=\"" + key + "\"]");
            self_1.classList.add('removing');
            setTimeout(function () {
                self_1.remove();
                document.querySelector('#race-cart-wrapper .qty-indicator').textContent = "" + TicketsocketCookie.data.length;
            }, animationTimeout);
        }
    };
    return (DOMcreateElement("div", { dataKey: key, className: "ticket-cart__line-item" },
        DOMcreateElement("p", { className: "eyebrow" }, lineItem.ticket),
        DOMcreateElement("div", { className: "name" },
            lineItem.name,
            DOMcreateElement("i", { onClick: remove, dataKey: key, className: "icon-delete" }),
            DOMcreateElement("span", { className: "qty" }, lineItem.count))));
}
